/**
 * Created by User on 28.10.2017.
 */

import {template} from 'lodash';
import {markdown} from "markdown"

const $photoCarouselTmpl = $('#photoCarouselTmpl');
const photoTmpl = template($photoCarouselTmpl.html());
let photoContext = window.photoContext;

/**
 * Sample context
 */
const about = `В нашем клубе два отдельных зала: **малый** для творческих занятий и **большой** с пятью зонами активности (зона развивающей гимнастики, зоны командных и персональных направлений спорта, силовая зона и круговая зона зала - зона эмоционального, когнитивного и нравственного здоровья)`

if (!photoContext) photoContext = {
  items: [
    {
      name: 'В нашем клубе',
      about: about,
      photo: './img/photo1-fullsize.png',
    },
    {
      name: '',
      about: about,
      photo: './img/photo1.png',
    },
    {
      name: '',
      about: about,
      photo: './img/photo2.png',
    },
    {
      name: '',
      about: about,
      photo: './img/photo3.png',
    },
    {
      name: '',
      about: about,
      photo: './img/photo4.png',
    },
    {
      name: '',
      about: about,
      photo: './img/photo5.png',
    },
    {
      name: '',
      about: about,
      photo: './img/photo6.png',
    },
    {
      name: '',
      about: about,
      photo: './img/photo7.png',
    },
  ]
};

photoContext.markdown = markdown;
// console.log('photoContext: ', photoContext);

// console.log(photoTmpl(photoContext));

if (photoContext) {
  $photoCarouselTmpl.replaceWith(photoTmpl(photoContext));
}


$(document).ready(() => {
  const $photoCarousel = $('#photoCarouselControls');
  const $photoCounter = $('#photo-counter .photo-counter-current');
  const $photoAbout = $('#equipment .photo-carousel-about');
  
  if ($photoCarousel) {
    const updatePhotoCounter = () => {
      const currentIndex = $photoCarousel.find('.carousel-item.active').index() + 1;
      const total = $photoCarousel.find('.carousel-item').length;
      $photoCounter.html(`${currentIndex}/${total}`);
      $photoAbout.html(markdown.toHTML(photoContext.items[currentIndex - 1].about));
    };

    $photoCarousel.on('slid.bs.carousel', updatePhotoCounter);
    updatePhotoCounter()
  }
});


// WEBPACK FOOTER //
// ./src/js/photo-carousel.js